package pl.decks.personal.pages.blog

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.layout.HorizontalDivider
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.layouts.site.SiteLayoutData
import pl.decks.personal.components.layouts.site.SiteLayoutScope
import pl.decks.personal.components.widgets.tag.ChipTag
import pl.decks.personal.components.widgets.tag.TagStylesheet.Chip
import pl.decks.personal.components.widgets.tag.TagStylesheet.Tag
import pl.decks.personal.components.widgets.tag.TagsList

@InitRoute
fun initBlogPostListingPage(ctx: InitRouteContext) {
    ctx.data.add(SiteLayoutData("Blog"))
}

@Page
@Layout(".components.layouts.site.SiteLayout")
@Composable
fun SiteLayoutScope.BlogPostListingPage() {
    val ctx = rememberPageContext()
    val filterTags = ctx.route.queryParams["filterTags"]?.split(",")?.distinct() ?: emptyList()
    val onBlogNavigated: () -> Unit = { closeMenu() }

    val entries = BlogPostRegistry.getEntries()
    val filteredEntries = entries.filter {
        filterTags.isEmpty() || filterTags.intersect(it.blogPostData.tags.toSet()).isNotEmpty()
    }
    val allTags = entries.flatMap { it.blogPostData.tags }.distinct()
    Column(
        modifier = BlogListingStylesheet.Page.toModifier(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        BlogPostListingHeader(allTags, filterTags)
        BlogPostsList(filteredEntries, filterTags, onBlogNavigated)
    }
}

@Composable
private fun BlogPostListingHeader(
    tags: List<String>,
    selectedTags: List<String>,
) = Column(
    modifier = BlogListingStylesheet.Header.Container.toModifier(),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    SpanText("Blog Posts", modifier = BlogListingStylesheet.Header.Title.toModifier())
    BlogListingTagChips(tags, selectedTags)
    HorizontalDivider()
}

@Composable
private fun BlogListingTagChips(
    tags: List<String>,
    selectedTags: List<String>,
) = TagsList(Modifier.fillMaxWidth()) {
    tags.forEach { tag ->
        NavigableTag(tag, selectedTags) {
            val isSelected = selectedTags.contains(tag)
            ChipTag(
                tag,
                outlineVariant = if (isSelected) Chip.SelectedVariant else Chip.RestingVariant,
                tagVariant = if (isSelected) Tag.InversedVariant else Tag.ActiveVariant,
            )
        }
    }
}

@Composable
private fun BlogPostsList(
    posts: List<BlogPostEntry>,
    selectedTags: List<String>,
    onBlogNavigated: () -> Unit,
) = Column(BlogListingStylesheet.Card.Listing.toModifier()) {
    posts.forEach { blogPost ->
        BlogPostCard(blogPost, selectedTags, onBlogNavigated)
    }
}
